import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { BbitWebShopCartService } from '@bbitgmbh/webshop.sdk';
import { BbitWebsiteService } from '@bbitgmbh/website.sdk';
import { NgIcon } from '@ng-icons/core';
import { SearchBoxComponent } from '../algolia/search-box/search-box.component';
import { SideNavComponent } from '../side-nav/side-nav.component';

@Component({
  selector: 'app-shop',
  templateUrl: './shop.component.html',
  styleUrls: ['./shop.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SideNavComponent, RouterOutlet, SearchBoxComponent, NgIcon, RouterLink, AsyncPipe],
})
export class ShopComponent implements OnInit {
  public website = inject(BbitWebsiteService);
  public cart = inject(BbitWebShopCartService);
  ngOnInit(): void {}
}
